import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const inboundTaskRBAC = {
  pageID: 'd1c3176c63e09a658fdc0420464091b7',
  elementID: {
    TableData: '1ea2596a2be275a5b0241f36ca65a77d',
    BtnActionPartialGrn: 'fb593aca52e9d82c32415bb5172d50c9',
  },
} as const

export const useRBACInboundTaskPage = createUseRBAC(inboundTaskRBAC.elementID)

export type UseRBACInboundTaskPageType = ReturnType<typeof useRBACInboundTaskPage>
